export const UserToken = 'UserToken'
export const UserInfo = 'UserInfo'
export const AnswerResult = 'AnswerResult'



// WEBPACK FOOTER //
// ./src/lib/AppConstant.js